module.exports = require("./../../_gen/starling/assets/AssetFactory");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/assets/AssetFactory.js
// module id = 132
// module chunks = 0